import debounce from '../util/debounce';
import Listeners from '../vendor/theme-scripts/listeners';
import {register} from '../vendor/theme-scripts/theme-sections';

const selectors = {
  tabs: '[data-tabs]',
  tabsNav: '[data-tabs-nav]',
  tabsContents: '[data-tabs-contents]',
  tabTitle: '[data-tab-title]',
  tabContent: '[data-tab-content]',
};

const classes = {
  active: 'is-active',
};

const sections = {};

class Tabs {
  constructor(container) {
    this.container = container;
    this.tabs = this.container.querySelector(selectors.tabs);
    this.resizeEvent = debounce(() => this.prepareTabs(), 250);
    this._listeners = new Listeners();

    if (this.tabs) {
      this.tabsNav = this.tabs.querySelector(selectors.tabsNav);
      this.tabsContents = this.tabs.querySelector(selectors.tabsContents);
      this.tabTitles = this.tabs.querySelectorAll(selectors.tabTitle);
      this.tabContents = this.tabs.querySelectorAll(selectors.tabContent);

      this.init();
    }
  }

  init() {
    this.prepareTabs();
    window.addEventListener('resize', this.resizeEvent);

    this.tabTitles.forEach((tabTitle, index) => {
      this._listeners.add(tabTitle, 'click', () => this.tabTitleClick(tabTitle, index));
    });
  }

  prepareTabs() {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (windowWidth <= theme.sizes.small) {
      this.tabTitles.forEach((tabTitle, index) => {
        this.tabs.appendChild(tabTitle);
        this.tabs.appendChild(this.tabContents[index]);
      });
    } else {
      this.tabTitles.forEach((tabTitle, index) => {
        this.tabsNav.appendChild(tabTitle);
        this.tabsContents.appendChild(this.tabContents[index]);
      });
    }
  }

  tabTitleClick(tabTitle, index) {
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const isActive = tabTitle.classList.contains(classes.active);
    const tabsCount = this.tabTitles.length;
    let tabIndex = index;

    // Do nothing if there's a single tab on Desktop
    if (tabsCount === 1 && windowWidth > theme.sizes.small) {
      return false;
    }

    if (isActive) {
      tabIndex += 1;

      // Check if next tab exists or set to first
      if (this.tabTitles[tabIndex] === undefined) {
        tabIndex = 0;
      }
    }

    this.tabTitles.forEach((tabTitle, i) => {
      tabTitle.classList.remove(classes.active);
      this.tabContents[i].classList.remove(classes.active);
    });

    this.tabTitles[tabIndex].classList.add(classes.active);
    this.tabContents[tabIndex].classList.add(classes.active);

    if (windowWidth <= theme.sizes.small) {
      setTimeout(() => {
        const titleTop = this.tabTitles[tabIndex].getBoundingClientRect().top - document.body.getBoundingClientRect().top - theme.dimensions.headerScrolled;

        window.scrollTo({
          top: titleTop,
          left: 0,
          behavior: 'smooth',
        });
      }, 300);
    }
  }

  triggerClick(evt) {
    const isActive = evt.target.classList.contains(classes.active);

    if (isActive) {
      return;
    }

    evt.target.dispatchEvent(new Event('click'));
  }

  onUnload() {
    window.removeEventListener('resize', this.resizeEvent);
    this._listeners.removeAll();
  }
}

const tabs = {
  onLoad() {
    sections[this.id] = new Tabs(this.container);
  },
  onBlockSelect(e) {
    sections[this.id].triggerClick(e);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
};

register('tabs', [tabs]);
